export default __webpack_public_path__ + "static/about-br-39f2d12e8dd53f7141cd5313ee242819.png";